import React from 'react';

const PremiumCard = ({ title, children, className = "", icon }) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden ${className}`}>
      {(title || icon) && (
        <div className="p-6 border-b border-gray-50 flex items-center gap-2">
          {icon && <span className="text-orange-600">{icon}</span>}
          {title && <h2 className="text-xl font-bold text-gray-800 tracking-tight">{title}</h2>}
        </div>
      )}
      <div className="p-6">
        {children}
      </div>
    </div>
  );
};

export default PremiumCard;
